module.exports = __webpack_public_path__ + "4c315f709f7395b40b73627b97166e0b.svg";